module.exports = __webpack_public_path__ + "static/media/hero_desktop.9a2b03f7.webp";